import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';

const routes: Routes = [
    {
        path: 'index',
        canActivate: [AuthGuard],
        loadChildren: () => import('./index/index.module').then(m => m.IndexPageModule)
    },
    {
        path: 'activities/:id/activities',
        loadChildren: () => import('./create-related-report/create-related-report.module').then(m => m.CreateRelatedReportPageModule)
    },
    {
        path: 'create-report',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-report/create-report.module').then(m => m.CreateReportPageModule)
    },
    {
        path: 'create-event',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-event/create-event.module').then(m => m.CreateEventPageModule)
    },
    {
        path: 'create-project',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-project/create-project.module').then(m => m.CreateProjectPageModule)
    },
    {
        path: 'create-institution',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-institution/create-institution.module').then(m => m.CreateInstitutionPageModule)
    },
    {
        path: 'create-profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-profile/create-profile.module').then(m => m.CreateProfilePageModule)
    },
    {
        path: 'edit-profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('./edit-profile/edit-profile.module').then(m => m.EditProfilePageModule)
    },
    {
        path: '',
        loadChildren: () => import('./getting-started/getting-started.module').then(m => m.GettingStartedPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'register',
        loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule)
    },
    {
        path: 'benefits/index',
        canActivate: [AuthGuard],
        loadChildren: () => import('./benefits/index/index.module').then(m => m.IndexPageModule)
    },
    {
        path: 'benefits/show/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./benefits/show/show.module').then(m => m.ShowPageModule)
    },
    {
        path: 'benefits/details',
        canActivate: [AuthGuard],
        loadChildren: () => import('./benefits/details/details.module').then(m => m.DetailsPageModule)
    },
    {
        path: 'my-digital-card',
        canActivate: [AuthGuard],
        loadChildren: () => import('./my-digital-card/my-digital-card.module').then(m => m.MyDigitalCardPageModule)
    },
    {
        path: 'companies',
        canActivate: [AuthGuard],
        loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesPageModule)
    },
    {
        path: 'projects',
        canActivate: [AuthGuard],
        loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsPageModule)
    },
    {
        path: 'events',
        canActivate: [AuthGuard],
        loadChildren: () => import('./events/events.module').then(m => m.EventsPageModule)
    },
    {
        path: 'reports',
        canActivate: [AuthGuard],
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsPageModule)
    },
    {
        path: 'staff-report',
        canActivate: [AuthGuard],
        loadChildren: () => import('./staff-report/staff-report.module').then(m => m.StaffReportPageModule)
    },
    {
        path: 'duplicates-review',
        canActivate: [AuthGuard],
        loadChildren: () => import('./duplicates-review/duplicates-review.module').then(m => m.DuplicatesReviewPageModule)
    },
    {
        path: 'contacts',
        canActivate: [AuthGuard],
        loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsPageModule)
    },
    {
        path: 'create-contact',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-contact/create-contact.module').then(m => m.CreateContactPageModule)
    },
    {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersPageModule)
    },
    {
        path: 'edit-password',
        loadChildren: () => import('./edit-password/edit-password.module').then(m => m.EditPasswordPageModule)
    },
    {
        path: 'edit-contact',
        loadChildren: () => import('./edit-contact/edit-contact.module').then(m => m.EditContactPageModule)
    },
    {
        path: 'create-affiliate',
        loadChildren: () => import('./create-affiliate/create-affiliate.module').then(m => m.CreateAffiliatePageModule)
    },
    {
        path: 'activity-details',
        loadChildren: () => import('./activity-details/activity-details.module').then(m => m.ActivityDetailsPageModule)
    },
    {
        path: 'activity/:id',
        loadChildren: () => import('./activity-details/activity-details.module').then(m => m.ActivityDetailsPageModule)
    },
    {
        path: 'activities/:id',
        loadChildren: () => import('./activity-details/activity-details.module').then(m => m.ActivityDetailsPageModule)
    },
    {
        path: 'activity-gallery',
        loadChildren: () => import('./activity-gallery/activity-gallery.module').then(m => m.ActivityGalleryPageModule)
    },
    {
        path: 'user-areas',
        loadChildren: () => import('./user-areas/user-areas.module').then(m => m.UserAreasPageModule)
    },
    {
        path: 'create-benefit',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-benefit/create-benefit.module').then(m => m.CreateBenefitPageModule)
    },
    {
        path: 'benefits',
        canActivate: [AuthGuard],
        loadChildren: () => import('./benefits/benefits.module').then(m => m.BenefitsPageModule)
    },
    {
        path: 'benefit-companies',
        canActivate: [AuthGuard],
        loadChildren: () => import('./benefit-companies/benefit-companies.module').then(m => m.BenefitCompaniesPageModule)
    },
    {
        path: 'create-benefit-company',
        canActivate: [AuthGuard],
        loadChildren: () => import('./create-benefit-company/create-benefit-company.module').then(m => m.CreateBenefitCompanyPageModule)
    },
    {
        path: 'create-benefit-company-type',
        loadChildren: () => import('./create-benefit-company-type/create-benefit-company-type.module').then(m => m.CreateBenefitCompanyTypePageModule)
    },
    {
        path: 'benefit-company-types',
        loadChildren: () => import('./benefit-company-types/benefit-company-types.module').then(m => m.BenefitCompanyTypesPageModule)
    },
    {
        path: 'teams',
        loadChildren: () => import('./teams/teams.module').then(m => m.TeamsPageModule)
    },
    {
        path: 'password-request',
        loadChildren: () => import('./password-request/password-request.module').then(m => m.PasswordRequestPageModule)
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsPageModule)
    },
    {
        path: 'activity-types',
        loadChildren: () => import('./activity-types/activity-types.module').then(m => m.ActivityTypesPageModule)
    },
    {
        path: 'create-activity-type',
        loadChildren: () => import('./create-activity-type/create-activity-type.module').then(m => m.CreateActivityTypePageModule)
    },
    {
        path: 'settings-catalogues',
        loadChildren: () => import('./settings-catalogues/settings-catalogues.module').then(m => m.SettingsCataloguesPageModule)
    },
    {
        path: 'catalogues-benefits',
        loadChildren: () => import('./catalogues-benefits/catalogues-benefits.module').then(m => m.CataloguesBenefitsPageModule)
    },
    {
        path: 'create-team',
        loadChildren: () => import('./create-team/create-team.module').then(m => m.CreateTeamPageModule)
    },
    {
        path: 'edit-team',
        loadChildren: () => import('./edit-team/edit-team.module').then(m => m.EditTeamPageModule)
    },
    {
        path: 'team-invitations/:id',
        loadChildren: () => import('./show-team-invitation/show-team-invitation.module').then(m => m.ShowTeamInvitationPageModule)
    },
    {
        path: 'team-invitations',
        loadChildren: () => import('./team-invitations/team-invitations.module').then(m => m.TeamInvitationsPageModule)
    },
    {
        path: 'create-feedback',
        loadChildren: () => import('./create-feedback/create-feedback.module').then(m => m.CreateFeedbackPageModule)
    },
    {
        path: 'edit-report',
        canActivate: [AuthGuard],
        loadChildren: () => import('./edit-report/edit-report.module').then(m => m.EditReportPageModule)
    },
    {
        path: 'activities-requests',
        loadChildren: () => import('./activities-requests/activities-requests.module').then(m => m.ActivitiesRequestsPageModule)
    },
    {
        path: 'agenda',
        canActivate: [AuthGuard],
        loadChildren: () => import('./agenda/agenda.module').then(m => m.AgendaPageModule)
    },


];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
